export default "__VITE_ASSET__x_TpCjZv__"